import * as React from 'react';
import PropTypes from 'prop-types';

const SvgSportsYogaNormalXsmall = React.forwardRef(
  ({ color, size, title, titleId, ...props }, ref) => (
    <svg
      fill={color}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 16 16"
      ref={ref}
      width={size}
      height={size}
      aria-labelledby={titleId}
      {...props}
    >
      {title ? <title id={titleId}>{title}</title> : null}
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.68 12.13a1.59 1.59 0 01-.74-.13l-.16-.08-5.284-2.6-.006.01a1.79 1.79 0 01-1-1.51A2.11 2.11 0 012.3 5.67a1.8 1.8 0 011.186.207L4.8 6.51l4.72-2.07 5.97 2.99v1.263L8.46 12a1.81 1.81 0 01-.78.13zM5.97 7.07L9.45 5.5l5 2.5L8 11a.77.77 0 01-.34.08.8.8 0 01-.35-.063l-.091-.044a1.001 1.001 0 01-.409-.663l1.19.6.24-.15A1.54 1.54 0 009 9a1.42 1.42 0 00-.81-.91L5.97 7.07zm1.964 2.04a.398.398 0 00-.273-.04c-.188.03-.363.147-.5.28l.79.4a.48.48 0 00.12-.44.471.471 0 00-.137-.2zM2.887 6.7l3.728 1.79a1.91 1.91 0 00-.785 1.47 1.64 1.64 0 000 .23c0 .039.003.077.005.115L1.995 8.45 2 8.44a.78.78 0 01-.46-.67 1.11 1.11 0 01.92-1.12.91.91 0 01.427.05z"
        fill=""
      />
    </svg>
  )
);
SvgSportsYogaNormalXsmall.defaultProps = {
  color: 'currentColor',
  size: 16,
  title: undefined,
  titleId: undefined
};
SvgSportsYogaNormalXsmall.propTypes = {
  color: PropTypes.string,
  size: PropTypes.number,
  title: PropTypes.string,
  titleId: PropTypes.string
};
export default SvgSportsYogaNormalXsmall;
